/** Форматирование для журнала: месяцы, даты, ссылки на карточку слушателя. */

import { studentCardPath } from './consts/educationType';

const MONTHS = [
  'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
  'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь',
];

const WEEKDAYS = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];

/** '2026-09' → 'Сентябрь 2026' */
export const formatMonth = (month) => {
  if (!month) return '';
  const [year, monthNumber] = month.split('-').map(Number);
  return `${MONTHS[monthNumber - 1]} ${year}`;
};

/** '2026-09-14' → '14.09.2026' */
export const formatDate = (date) => {
  if (!date) return '';
  const [year, month, day] = date.slice(0, 10).split('-');
  return `${day}.${month}.${year}`;
};

/** '2026-09-14' → 'пн' */
export const weekdayShort = (date) => (date ? WEEKDAYS[new Date(date).getDay()] : '');

export const shiftMonth = (month, delta) => {
  const [year, monthNumber] = month.split('-').map(Number);
  const date = new Date(year, monthNumber - 1 + delta, 1);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
};

/**
 * Сегодняшняя дата и текущий месяц — по местному календарю.
 *
 * `toISOString()` сначала переводит время в UTC. В Екатеринбурге это минус пять часов:
 * до 05:00 «сегодня» превращалось во вчера, а в первую ночь месяца журнал открывался
 * на прошлом месяце. Собираем строку из локальных компонентов.
 */
const pad = (value) => String(value).padStart(2, '0');

export const todayString = () => {
  const now = new Date();
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
};

export const currentMonth = () => todayString().slice(0, 7);

/**
 * Имя слушателя для журнала.
 *
 * Сотрудники отделения работают со списками на русском, поэтому показываем `russian_name`.
 * Он заполнен не у всех — у таких остаётся латинское написание из паспорта, иначе
 * человек пропал бы из списка вовсе.
 */
export const studentName = (student) => (student
  ? (student.russian_name || student.latin_name || '—')
  : '—');

/**
 * Ссылка на карточку слушателя. Формат тот же, что в общей таблице контингента
 * (AnyRolesHeaderCells): тип обучения определяет раздел.
 */
export const studentCardLink = (student) =>
  studentCardPath(student.education_type, student.student_id || student.id);

/** 'Пелымская Елена Сергеевна' → 'Пелымская Е. С.' — для узких колонок журнала. */
export const shortName = (name) => {
  if (!name) return '';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0];
  return `${parts[0]} ${parts.slice(1).map((part) => `${part[0]}.`).join(' ')}`;
};

/** Инициалы для подписи в шапке столбца: 'Пелымская Елена' → 'ПЕ'. */
export const initials = (name) => {
  if (!name) return '';
  const parts = name.trim().split(/\s+/);
  return parts.slice(0, 2).map((part) => part[0].toUpperCase()).join('');
};
